import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SettingsSectionRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S32};
  width: 100%;
`
